import React from "react";
import { Typography } from "@mui/material";

import { createAvatarName, hasImage } from "../../../../../utils";
import Avatar from "../../../../../components/Avatar";
import Loader from "../../../../../components/Loader";
import CustomMenu from "../../../../../components/Menu";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { useBoardOwnerAssignment } from "../../hooks/useBoardOwnerAssignment";

function ListBoardUser({ anchorEl, open, handleClose, id, params }) {
  const {
    isLoading,
    sortedUsers,
    selectedUser,
    isDialogOpen,
    isSubmitting,
    selectBoardOwner,
    closeOwnerDialog,
    submitOwnerChange,
  } = useBoardOwnerAssignment({
    boardId: id,
    handleClose,
  });

  return (
    <>
      {isDialogOpen && (
        <FormDialog
          open={isDialogOpen}
          handleClose={closeOwnerDialog}
          handleSubmit={submitOwnerChange}
          loading={isSubmitting}
          buttonTxt={"Assign"}
          title={"Confirmation: Assign Board Owner"}
          alignActions={"center"}
          cancelBtn={true}
          width={500}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2 ">
            {`Are you sure to assign ${selectedUser?.username} as Board Owner?`}
          </Typography>
        </FormDialog>
      )}
      <CustomMenu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="assign-board-owner-list"
      >
        {isLoading && (
          <div className="loader-center">
            <Loader color={"black"} />
          </div>
        )}
        {sortedUsers.map((el) => {
          return (
            <CustomMenuItem
              key={`user-avtar-dropdown-admin-assign-${el?.user_id}`}
              onClick={() => selectBoardOwner(el)}
              className={
                params?.row?.board_owner_id == el?.user_id
                  ? "active-assign"
                  : ""
              }
            >
              <Avatar
                key={`user-avtar-${el?.user_id}`}
                username={el?.username}
                user_image={el?.user_image}
                title={el?.username}
                className="user-avtar-dropdown user-avatar mr-8"
                style={
                  !hasImage(el?.user_image) && {
                    bgcolor: el?.profile_color?.background,
                    color: el?.profile_color?.text,
                  }
                }
              >
                {createAvatarName(el?.username)}
              </Avatar>

              {el?.username}
            </CustomMenuItem>
          );
        })}
      </CustomMenu>
    </>
  );
}

const isChangeListBoardUser = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.board_owner_id === nextProps?.params?.row?.board_owner_id
  );
};

export default React.memo(ListBoardUser,isChangeListBoardUser);
